if (!customElements.get('ro-product-form')) {
  customElements.define(
    'ro-product-form',
    class RoProductForm extends HTMLElement {
      constructor() {
        super();

        this.hideErrors = this.dataset.hideErrors === 'true';

        this.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.variantIdInput.disabled = false;

        this.cart = document.querySelector('ro-cart-notification');

        if (document.querySelector('cart-drawer')) {
          this.submitButton?.setAttribute('aria-haspopup', 'dialog');
        }
      }

      /** @returns {HTMLFormElement|null} */
      get form() {
        return this.querySelector('form');
      }

      /** @returns {HTMLButtonElement|null} */
      get submitButton() {
        return this.querySelector('[type="submit"]');
      }

      /** @returns {HTMLElement|null} */
      get submitButtonText() {
        return this.submitButton?.querySelector('span');
      }

      onSubmitHandler(evt) {
        const submittedForm = evt.target?.closest?.('form');
        const liveForm = this.querySelector('form');
        if (!submittedForm || submittedForm !== liveForm) return;
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.ro-loading__status')?.classList.remove('tw-hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const variantMaxQty = parseInt(formData.get('maxqty'));        

        /**
         * Before submitting, the value of the "maxqty" input is checked:
         * - If exists and is greater than 0, the cart is checked:
         *    - If the variant to be added already exists and in a smaller quantity than the maxqty input, it is added.
         *    - If the maximum quantity per order has been reached, an informative popup is displayed.
         * - Otherwise, the submit is done
         */
        if (variantMaxQty && variantMaxQty > 0) {        
          fetch(`${Shopify.routes.root}cart.js`)
          .then(response => response.json())
          .then(cart => {
            const variantId = formData.get('id');
            const variantAlreadyAdded = cart.items.find(item => item.id == variantId);            
            
            if (variantAlreadyAdded && variantAlreadyAdded.quantity >= variantMaxQty) {
              publish(PUB_SUB_EVENTS.variantOrderMaxQtyReached, {
                variant: variantId,
              });
            } else {
              this.submitForm(formData, config);
            }
            
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.ro-loading__status')?.classList.add('tw-hidden');
          });
        } else {        
          this.submitForm(formData, config);
        }
      }

      submitForm(formData, config) {
        const runwayQuickAddModal = this.closest('ro-quick-add-modal-runway');
        this.cart = runwayQuickAddModal ? this.getCartNotification() : this.cart;
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'ro-product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'ro-product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('ro-quick-add-modal');
            if (!this.cart && !quickAddModal && !runwayQuickAddModal) {
              window.location = window.routes.cart_url;
              return;
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (runwayQuickAddModal) {
              this.cart?.renderContents(response);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.ro-loading__status')?.classList.add('tw-hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }

      /**
       * Returns the cart notification element used by Runway quick add
       * @returns {HTMLElement|null}
       */
      getCartNotification() {
        const cartNotification = document.querySelector('ro-cart-notification');
        if (!cartNotification) return null;
        if (typeof cartNotification.getSectionsToRender !== 'function') return null;
        if (typeof cartNotification.renderContents !== 'function') return null;
        return cartNotification;
      }
    }
  );
}
